import cardValidator from 'card-validator';
import humanparser from 'humanparser';

import { validateEmail } from '../../Shared/validations.js';

const validateFullName = values => {
    const name = humanparser.parseName(values.fullName || '');

    if (name.firstName == null || name.lastName === '') {
        return { fullName: 'Invalid Full Name' };
    }
    return {};
};

const validateCard = values => {
    const creditCardValidation = cardValidator.number(values.cardNumber);
    if (!creditCardValidation.isValid) {
        return { cardNumber: 'Invalid Credit Card Number' };
    } else {
        if (
            creditCardValidation.card &&
            creditCardValidation.card.code &&
            creditCardValidation.card.code.size
        ) {
            const cvvValidation = cardValidator.cvv(
                values.cvv,
                creditCardValidation.card.code.size
            );

            if (!cvvValidation.isValid) {
                return { cvv: 'Invalid CVV' };
            }
        }
    }
    return {};
};

const validateDate = values => {
    const dateValidation = cardValidator.expirationDate(values.expDate);
    if (!dateValidation.isValid) {
        return { expDate: 'Invalid Date' };
    }
    return {};
};

const validate = values => {
    const errors = {
        ...validateFullName(values),
        ...validateEmail(values),
        ...validateCard(values),
        ...validateDate(values)
    };

    return errors;
};

export const validatePersonalDetails = values => {
    const errors = {
        ...validateFullName(values),
        ...validateEmail(values)
    };

    return errors;
};

export const validateCardDetails = values => {
    const errors = {
        ...validateCard(values),
        ...validateDate(values)
    };

    return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/components/Donation/Form/validations.js